import Switch from './Switch';

export default Switch;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/switch/index.js
// module id = 438
// module chunks = 0